export const NAME = 'productCategories';
